Vue.component('checkout-form', {
  data() {
    return {
      submitInProcess: false,
      errors: [],
      discountMaxPercent: 15,
      discount: 1,
      deliveryPrice: 0,
      lastSelectedStreet: null,
      form: {
        phone: null,
        name: null,
        email: null,
        comment: null,
        discount: null,
        payment: 1,
        delivery: {
          type: 1,
          info: {
            pickup_address: 1,
            street: null,
            delivery_item_id: null,
            house: null,
            stage: null,
            floor: null,
            apartment: null,
            contact_type: null,
          },
          date: null,
          time: '',
        },
        payment_type: 1,
        coupon: {
          id: null,
          code: '',
          type: null,
          productSizeId: null,
          productSizes: [],
          productTitle: '',
          price: 0
        }
      },
      balance: 0,
      notBonusClient: false,
      pending: false,
      bonusError: '',
      bonusQuerySent: false,
      pendingCoupon: false,
      couponQuerySent: false,
      couponError: '',
      couponInput: '',
      couponAndBonusNotUsed: false,
      discountPickupValue: 0
    }
  },
  computed: {
    items() {
      return store.state.order.items;
    },
    orderPrice() {
      let price = 0;
      for (let item of this.items) {
        //к акционным товарам не применяется скидка
        price += this.getProductPrice(item) * item.count * (item.product.is_discount ? 1 : this.discount);
      }
      price += this.deliveryPrice;
      if (this.form.discount <= this.balance) {
        price -= this.form.discount
      }
      if (this.form.coupon.id !== null && +this.form.coupon.type === 3) {
        price += this.form.coupon.price
      }
      //10% скидка за самовывоз
      if (this.discountPickup) {
        price *= this.discountPickupValue;
      }
      return price;
    },
    orderPriceWithoutDiscount() {
      let price = 0;
      for (let item of this.items) {
        //к акционным товарам не применяется скидка
        let priceProduct = this.getProductPrice(item)
        price += priceProduct * item.count * (item.product.is_discount ? 1 : this.discount);
      }
      price += this.deliveryPrice;
      return price;
    },
    fullOrderPrice() {
      let price = 0;
      for (let item of this.items) {
        price += this.getProductPrice(item) * item.count;
      }
      if (this.form.coupon.id !== null && +this.form.coupon.type === 3) {
        price += this.form.coupon.price
      }
      return price;
    },
    isOnlinePaymentDisabled() {
      let currentDate = new Date()
      let startDate = new Date(currentDate.getTime());
      startDate.setHours(8, 0, 0, 0);
      let endDate = new Date(currentDate.getTime());
      endDate.setHours(22, 0, 0, 0);
      if (!(startDate < currentDate && endDate > currentDate)) {
        return true;
      }
      return this.form.delivery.info.pickup_address == 2;
    },
    isOnlyUniversitetskyaPickup() {
      for (let item of this.items) {
        if (item.product.isOnlyUniversitetskyaPickup) {
          return true;
        }
      }
      return false;
    },
    discountPickup() {
      return (+this.form.discount === 0) && this.form.coupon.id === null && +this.form.delivery.type === 2;
    },
    discountPickupSize() {
      if (this.discountPickup) {
        return this.orderPriceWithoutDiscount - this.orderPrice;
      } else {
        return 0;
      }
    }
  },
  watch: {
    'form.phone': function (val) {
      if (val === '+7 (8' || val === '+7 (88') {
        this.form.phone = '+7 (';
      }
    },
    'form.delivery.info.pickup_address': function (val) {
      if (val == 2) {
        this.form.payment_type = 1;
      }
    },
    'form.payment_type': function (val) {
      if (this.form.delivery.info.pickup_address == 2 && val == 3) {
        this.form.payment_type = 1;
      }
    },
    'form.discount': function (val) {
      let discountMaxPercent = (this.discountMaxPercent / 100).toFixed(2)
      if (+(this.orderPriceWithoutDiscount * discountMaxPercent).toFixed(2) < +val) {
        this.form.discount = +(this.orderPriceWithoutDiscount * discountMaxPercent).toFixed(2);
      }
      if (this.balance < this.form.discount) {
        this.form.discount = this.balance;
      }
      if (this.form.discount < 0) {
        this.form.discount = 0;
      }
      if (this.form.discount > 0 && this.form.coupon.id !== null) {
        this.removeCoupon();
        this.couponAndBonusNotUsed = true
      }
    },
    deep: true
  },
  methods: {
    changeStreet(street) {
      this.form.delivery.info.street = street.id
      this.form.delivery.info.delivery_item_id = street.delivery_item_id
      if (this.orderPrice >= this.getMinimalPriceForFreeDelivery() && street.delivery_has_discount) {
        this.deliveryPrice = 0;
      } else {
        this.deliveryPrice = street.delivery_cost;
      }
      this.lastSelectedStreet = street
    },
    getMinimalPriceForFreeDelivery() {
      let minimalPrice = 2000;
      for (let item of this.items) {
        if (item.product.custom_minimal_price_for_free_delivery !== null && item.product.custom_minimal_price_for_free_delivery < minimalPrice) {
          minimalPrice = item.product.custom_minimal_price_for_free_delivery
        }
      }
      return minimalPrice;
    },
    submitForm() {
      if (this.submitInProcess) {
        return;
      }
      this.submitInProcess = true;
      this.errors = [];
      if (this.items.length == 0) {
        this.errors.push("Ваша корзина пуста((");
      }
      if (!this.form.name) {
        this.errors.push("Заполните имя");
      }
      if (!this.form.phone) {
        this.errors.push("Заполните телефон");
      } else if (this.form.phone.substr(0, 5) === '+7 (8') {
        this.errors.push("Недопустимый номер телефона");
      }
      if (this.form.discount > this.balance) {
        this.errors.push("Потраченные баллы не могут превышать бонусный баланс");
      }
      if (!this.form.delivery.date || !this.form.delivery.time) {
        this.errors.push("Необходимо заполнить дату доставки");
      }/* else {
                let timestamp = this.getTimeStamp();
                if (timestamp * 1000 < (Date.now() + 3600000)) {
                    this.errors.push("Дата доставки должна быть не раньше чем через час");
                }
            }*/
      if (this.form.delivery.type == 1) {
        if (!this.form.delivery.info.street) {
          this.errors.push("Необходимо заполнить улицу");
        }
        if (!this.form.delivery.info.house) {
          this.errors.push("Необходимо заполнить дом");
        }
        if (this.form.delivery.info.house && this.form.delivery.info.house.length > 10) {
          this.errors.push("Длина значение Дом не должна превышать 10 символов");
        }
        if (this.form.delivery.info.house) {
          this.form.delivery.info.house = this.form.delivery.info.house.trim()
        }
        if (this.form.delivery.info.house && !/^[\wа-яА-ЯёЁ\-–\/ ]+$/.test(this.form.delivery.info.house)) {
          this.errors.push("Значение Дом может содержать только цифры, тире(-) и дробь(/)");
        } else if (this.form.delivery.info.house && !/[0-9]/.test(this.form.delivery.info.house)) {
          this.errors.push("Значение Дом должно содержать цифры");
        }
      }
      if (this.errors.length > 0) {
        this.submitInProcess = false;
        return;
      }
      // JS is perfect
      let data = JSON.parse(JSON.stringify(this.form));
      CsrfHelper.addCsrf(data);

      data.products = {};
      for (let item of this.items) {
        data.products[item.product.id] = item.count;
      }

      let _this = this;
      axios.post('/cart/send', data).then(response => {
        if (response.data.success) {
          store.dispatch('clearCart');
          window.location.href = response.data.redirect;
        } else {
          if (response.data.error) {
            _this.errors.push(response.data.error);
          }
        }
        this.submitInProcess = false;
      });
    },
    getTimeStamp() {
      let date = new Date(this.form.delivery.date);
      let time = new Date(+this.form.delivery.time);
      date.setHours(time.getHours());
      date.setMinutes(time.getMinutes());
      return date / 1000;
    },
    getName(product) {
      return ProductHelper.getTitle(product);
    },
    timeOptions() {
      let items = [];
      for (let i = 0; i < 13; i++) {
        let time = (this.form.delivery.type == 1) ? (8 + i) + ':00 - ' + (8 + i + 1) + ':00' : (8 + i) + ':00'
        items.push({
          time: time,//27.06.2022 заменили период, на просто время
          timeValue: 8 + i
        });
      }
      return items;
    },
    changeTime(event) {
      this.form.delivery.time = event.target.value;
    },
    formatPrice(price) {
      return price.toLocaleString('ru');
    },
    checkCoupon() {
      this.couponError = ''
      if (this.couponInput.length > 1) {
        this.pendingCoupon = true; // Ожидание появления;
        let products = ''
        for (let item of this.items) {
          products += '&products[]=' + item.product.id;
        }
        axios.get('/cart/check-coupon?coupon=' + this.couponInput + '&price=' + this.fullOrderPrice + products).then(response => {
          if (response.data.success) {
            this.pendingCoupon = false;
            this.form.coupon.id = response.data.data.couponId
            this.form.coupon.code = response.data.data.couponCode
            this.form.coupon.type = response.data.data.couponType
            this.form.coupon.productSizeId = response.data.data.productSizeId
            this.form.coupon.productSizes = response.data.data.productSizes
            this.form.coupon.productTitle = response.data.data.productTitle
            this.form.coupon.price = +response.data.data.price
            if (this.form.discount != 0) {
              this.couponAndBonusNotUsed = true
            }
            this.form.discount = 0
            if (this.lastSelectedStreet) {
              this.changeStreet(this.lastSelectedStreet)
            }
          } else {
            this.removeCoupon()
            this.couponError = response.data.message;
          }
          this.couponQuerySent = true;
          this.submitInProcess = false;
          this.pendingCoupon = false;
        });
      }
    },
    removeCoupon() {
      this.form.coupon.id = null
      this.form.coupon.code = ''
      this.form.coupon.type = null
      this.form.coupon.productSizeId = null
      this.form.coupon.productTitle = ''
      this.form.coupon.price = 0
      this.couponError = ''
      if (this.lastSelectedStreet) {
        this.changeStreet(this.lastSelectedStreet)
      }
    },
    getBalance() {
      this.notBonusClient = false
      this.balance = 0
      this.errors = [];
      this.bonusError = ''
      if (!this.form.phone) {
        this.errors.push("Заполните телефон");
      }

      this.pending = true; // Ожидание появления;

      axios.get('/cart/get-balance?phone=' + this.form.phone).then(response => {
        if (response.data.success) {
          this.pending = false;
          this.balance = response.data.data.balance
        } else {
          this.bonusError = response.data.message;
          this.notBonusClient = true;
        }
        this.submitInProcess = false;
        this.pending = false;
        this.bonusQuerySent = true;
      });
      if (this.lastSelectedStreet) {
        this.changeStreet(this.lastSelectedStreet)
      }
    },
    getProductPrice(item) {
      let priceProduct = item.product.price
      if (this.form.coupon.id !== null && +this.form.coupon.type === 4 && this.form.coupon.productSizes.length > 0) {
        priceProduct = this.form.coupon.productSizes.map(item => item.id).indexOf(item.product.id) > -1 ? this.form.coupon.price : priceProduct;
      }
      return priceProduct;
    },
    reduceItems(item) {
      item.count--;
      item.count = ProductHelper.changeCount(item.product, item.count, true);
      store.dispatch('setItemInCart', {
        product_id: item.product.id,
        count: item.count
      });
    },
    addItems(item) {
      item.count++;
      item.count = ProductHelper.changeCount(item.product, item.count);
      store.dispatch('setItemInCart', {
        product_id: item.product.id,
        count: item.count
      });
    },
    deleteItem(item, event) {
      if (event) {
        event.stopPropagation();
      }
      store.dispatch('updateItemInCart', {product_id: item.product.id, updateDirection: 0});
    },
  },
  mounted() {
    this.discountPickupValue = +this.$el.getAttribute('data-discount-pickup-value');
  },
});
